import React, { useCallback, useEffect, useRef, useState } from 'react'
import Masonry from 'react-masonry-css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConversionCampaignsThunk, setSearchQuery } from '../../redux-stores/slices/conversionCampaignSlice';
import { AppDispatch, RootState } from '../../redux-stores/store';
import { useNavigate } from 'react-router-dom';
import { formatAmount, generateUniqueKey } from '../../utils/helpers';
import Skeleton from 'react-loading-skeleton';

const breakpointColumnsObj = {
    default: 4,
    600: 2,
    900: 3
};
const ConversionCampaignsList: React.FC<{ searchQuery: string }> = ({ searchQuery }) => {

    const dispatch = useDispatch<AppDispatch>();

    const navigate = useNavigate();

    const filters = useSelector((state: RootState) => state.conversionCampaigns.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));

    const campaignsData = useSelector((state: RootState) => state.conversionCampaigns.filtered_list[filterId!]);
    const has_more = campaignsData?.has_more ?? true;
    const page = campaignsData?.page ?? 1;
    const campaigns = campaignsData?.list ?? [];

    const loading = useSelector((state: RootState) => state.conversionCampaigns.loading);

    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        setInitialLoading(true);
        dispatch(fetchConversionCampaignsThunk({ filters })).finally(() => {
            setFilterId(generateUniqueKey(filters, ['page']));
            setInitialLoading(false);
        })
    }, [filters, dispatch])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            fetchCampaignsData(nextPageNumber)
        }

    }

    const fetchCampaignsData = useCallback(async (pageNumber: number) => {
        await dispatch(fetchConversionCampaignsThunk({ filters: { ...filters, page: pageNumber } }));
    }, [dispatch, filters]);


    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (searchQuery.trim().length > 2 || searchQuery.trim().length === 0) {
                dispatch(setSearchQuery(searchQuery))
            }
        }, 500);

        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, [searchQuery, dispatch]);



    return (
        <div className='p-3'>
            <InfiniteScroll
                dataLength={campaigns.length} // Number of currently loaded campaigns
                next={nextPage}
                hasMore={has_more} // True if there are more campaigns to load
                loader={<></>}
            >
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                >
                    {!initialLoading && campaigns.map((campaign, i) => (
                        <div onClick={() => navigate(`/conversion/${campaign.uuid}`)} key={i} className="conversion-campaign-card">
                            <div className="conversion-campaign-card-header">
                                <div className="conversion-campaign-brand-logo bg-image bgc-white" style={{ backgroundImage: `url(${campaign.img_url})` }}></div>
                            </div>
                            <div className="conversion-campaign-card-body">
                                <div className="brand-detail">
                                    <span className='coversion-campaign-brand-name text-center'>{campaign.name}</span>
                                    {/* <span className="brand-category">{campaign.category}</span> */}
                                </div>
                                <span className='conversion-campaign-commission text-truncate text-center'>
                                    {campaign.min_commission === campaign.max_commission ? "Flat " : "Upto "}
                                    {campaign.commission_type === 'percent' ? `${campaign.max_commission}% ` : `${formatAmount(campaign.max_commission, campaign.currency?.code, campaign.currency?.symbol, campaign.currency?.locale)} `}
                                </span>
                            </div>
                        </div>
                    ))}
                    {
                        (initialLoading || loading) && Array.from({ length: 6 }).map((_, i) => {
                            return (
                                <div className="conversion-campaign-card" key={i}>
                                    <div className="conversion-campaign-card-header">
                                        <Skeleton height={100} width={100} className='conversion-campaign-brand-logo' />
                                    </div>
                                    <div className='conversion-campaign-card-body'>
                                        <Skeleton height={10} width={'100%'} />
                                        <Skeleton height={10} width={'100%'} />
                                    </div>
                                </div>
                            )
                        })
                    }
                </Masonry>
            </InfiniteScroll>
            {
                campaigns.length === 0 && !initialLoading && !loading && (
                    <div className="d-flex w-100 justify-content-center align-items-center my-5">
                        <div className="length-zero my-1">
                            <h3>
                                No campaigns found
                            </h3>
                        </div>
                    </div>
                )
            }
        </div>

    )
}

export default ConversionCampaignsList